import moment from "moment";
import { EnumEstadoAutorizacionInformeConservacion, EnumEstadoInformeConservacion, } from "../../../Utils/Enumeradores/ComunEnum";

export const COLUMNS = [
	{
		Header: 'ID',
		accessor: 'informeConservacionId',
	},
	{
		Header: 'Archivo',
		accessor: 'nombreArchivoEstandar',
        Cell: ({row}) => <a
                href={row.original.rutaArchivo}
                target="_blank"
                rel="noopener noreferrer"
                download={row.original.nombreArchivoEstandar}
                style={{ color: "blue" }}
            >
            {row.original.nombreArchivoEstandar}
      </a>
	},
    {
		Header: 'Exigencia',
		accessor: 'exigencia.sigla',
	},
	{
		Header: 'Cant. Registros',
		accessor: 'cantidadRegistros',
	},
	{
		Header: 'Fecha Carga',
		accessor: 'fechaCarga',
        Cell: ({row}) => <spam>
			{moment(row.original.fechaCarga).format('DD-MM-YYYY')}
		</spam>
	},
    {
		Header: 'Fecha Envio Bitácora',
		accessor: 'fechaInformado',
        Cell: ({row}) => <spam>
			{moment(row.original.fechaInformado).format('DD-MM-YYYY')}
		</spam>
	},
	{
		Header: 'Origen',
		accessor: 'usuarioCarga.origen',
	},
	{
		Header: 'Estado',
		accessor: 'estado',
        Cell: ({row}) => 
            <span>
                {EnumEstadoInformeConservacion[row.original.estado]}
            </span>
        
	},
	{
		Header: 'Estado Autorización IF',
		accessor: 'estadoAutorizacion',
		Cell: ({ row }) => 
		<span>
			{row.original.estadoAutorizacion === EnumEstadoAutorizacionInformeConservacion.Pendiente ? "Pendiente" : row.original.estadoAutorizacion === EnumEstadoAutorizacionInformeConservacion.Autorizado ? "Autorizada" : row.original.estadoAutorizacion === EnumEstadoAutorizacionInformeConservacion.Rechazado ? "Rechazada" : ""}
		</span>
	},
	{
		Header: 'Usuario',
		accessor: 'usuarioCarga',
		Cell: ({ row }) => <span>{row.original.usuarioCarga.nombres + " " + row.original.usuarioCarga.apellidoPaterno }</span>
	},
]
